import { StyledMaxWidth, Table } from '@dreryk/react-components';

import {
   usePredefinedPatientGroupsTableColumnsConfiguration,
   usePredefinedPatientGroupsTableDataConfiguration,
} from './PredefinedPatientGroupsTable.hooks';

export const PredefinedPatientGroupsTable = (): JSX.Element => {
   return (
      <StyledMaxWidth maxWidth={'870px'}>
         <Table
            testId={'predefinedPatientGroups'}
            dataConfiguration={usePredefinedPatientGroupsTableDataConfiguration()}
            columns={usePredefinedPatientGroupsTableColumnsConfiguration()}
            keyExtractor={'id'}
            compact
         />
      </StyledMaxWidth>
   );
};
